module.exports = __webpack_public_path__ + "static/media/buy_house.e8c98e12.svg";